<div class="content-container" >
  <ng-container *ngIf="!loadIndicator; else loading" >
    <div class="tab-content team" *ngIf="participants != 0; else nodata">

    <ng-container *ngFor="let participant of participants">
  <div class="team-block">
    <app-player-card-resuable  [backgroundImageBody]="'linear-gradient(to left, #cb3066, #cb3066 5%, #16bffd)'" [participant]="participant">
    </app-player-card-resuable>
  </div>


    </ng-container>
    </div>

  </ng-container>
  <ng-template #nodata>
    <div class="no-data " *ngIf="participants?.length==0">
      <h2>{{globalService.customLang.no_winners}}</h2>
    </div>
  </ng-template>
</div>
  <ng-template #loading>
    <app-loading-indicator></app-loading-indicator>
  </ng-template>
